import { IconProps } from '@/shared/lib/types'

type StatusProps = IconProps & {
  children: React.ReactNode
  size?: 'sm' | 'md'
}

export const StatusLabel = ({ children, size, status, className }: StatusProps) => {
  const baseClasses =
    'relative rounded-full pl-[30px] pr-4 before:absolute before:h-[6px] before:w-[6px] before:rounded-full before:top-[50%] before:left-[16px] before:-translate-y-[50%] w-fit whitespace-nowrap'

  const typeClasses = {
    green:
      'bg-[var(--status-green-fill)] text-[var(--status-green-stroke)] before:bg-[var(--status-green-stroke)]',
    red: 'bg-[var(--status-red-fill)] text-[var(--status-red-stroke)] before:bg-[var(--status-red-stroke)]',
    grey: 'bg-[var(--status-grey-fill)] text-[var(--status-grey-stroke)] before:bg-[var(--status-grey-stroke)]',
    yellow:
      'bg-[var(--status-yellow-fill)] text-[var(--status-yellow-stroke)] before:bg-[var(--status-yellow-stroke)]',
    purple:
      'bg-[var(--status-purple-fill)] text-[var(--status-purple-stroke)] before:bg-[var(--status-purple-stroke)]',
    none: '',
  }[status]

  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
  }[size || 'md']

  return (
    <div className={`${baseClasses} ${typeClasses} ${sizeClasses} ${className || ''}`}>
      {children}
    </div>
  )
}
